import { render } from "./TextElement.vue.js?vue&type=template&id=6296fa14&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=template&id=6296fa14&scoped=true"
import script from "./TextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=script&lang=js"

import "./TextElement.vue.scss?vue&type=style&index=0&id=6296fa14&lang=scss&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=style&index=0&id=6296fa14&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6296fa14"],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/text-element/TextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6296fa14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6296fa14', __exports__)) {
    api.reload('6296fa14', __exports__)
  }
  
  module.hot.accept("./TextElement.vue.js?vue&type=template&id=6296fa14&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=template&id=6296fa14&scoped=true", () => {
    api.rerender('6296fa14', render)
  })

}


export default __exports__